// obsolete: do not use this in new code, it is just for keeping old code working
function commonErrorHandler (type, { dispatch, update }) {
  dispatch({ type, data: update })
}

export default commonErrorHandler // for backward compatibility

export {
  commonErrorHandler // preferred
}



// WEBPACK FOOTER //
// ./src/utils/errors.js